/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

export type FunctionEnvironmentVariable = {
  /**
   * Optional value of the function variable comes from a specific auth input
   */
  authInputType?: string | undefined;
  /**
   * Description of the function environment variable
   */
  description?: string | undefined;
  /**
   * The environment variables
   */
  name: string;
};

/** @internal */
export const FunctionEnvironmentVariable$inboundSchema: z.ZodMiniType<
  FunctionEnvironmentVariable,
  unknown
> = z.pipe(
  z.object({
    auth_input_type: z.optional(z.string()),
    description: z.optional(z.string()),
    name: z.string(),
  }),
  z.transform((v) => {
    return remap$(v, {
      "auth_input_type": "authInputType",
    });
  }),
);

export function functionEnvironmentVariableFromJSON(
  jsonString: string,
): SafeParseResult<FunctionEnvironmentVariable, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => FunctionEnvironmentVariable$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'FunctionEnvironmentVariable' from JSON`,
  );
}
